module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/firehose-2015-08-04.paginators.json
// module id = 506
// module chunks = 30